import { FC, Fragment, useEffect, useState } from 'react';
import Button from 'components/ui/Button/Button';
import { useTranslation } from 'react-i18next';
import { sendEmailProposal } from 'services/hotel';
import { showSuccess } from 'utils/utils';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface PdfPrintOrSendProps {
  email?: string;
  pdfUrl?: string;
  show: boolean;
}
const PdfPrintOrSend: FC<PdfPrintOrSendProps> = (props) => {
  const [t] = useTranslation();
  const [email, setEmail] = useState(props.email);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setEmail(props.email);
  }, [props.email]);

  const sendEmail = async () => {
    if (!email || !props.pdfUrl) {
      return;
    }
    setLoading(true);
    const response = await sendEmailProposal(email, props.pdfUrl);

    if (!response.hasErrors) {
      showSuccess(t('mo.email_success'));
    }
    setLoading(false);
  };

  return (
    <Fragment>
      {props.show && (
        <div className="btns-row">
          {!!props.pdfUrl && (
            <a className="btn btn-primary" href={props.pdfUrl} download={true}>
              {t('proposal.download_pdf')}
            </a>
          )}
          {!props.pdfUrl && (
            <Button
              className="btn btn-primary"
              disabled={true}
              title={t('proposal.download_pdf')}
            />
          )}
          <div className="input-block">
            <div>
              <input
                value={email}
                className="form-control"
                onChange={(event) => setEmail(event.target.value)}
              />
            </div>
            <Button
              className="btn btn-default"
              title={t('proposal.send_email')}
              onClick={sendEmail}
              disabled={loading}
            />
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default withErrorBoundary(PdfPrintOrSend, 'PdfPrintOrSend');
